export default __webpack_public_path__ + "static/media/txt.58823fce.svg";